/// <reference path="../../../typings/index.d.ts" />
/// <reference path="../apimodel.d.ts" />

declare module App.Common {

	export interface IApiRequestConfig {

		resourceName?: string;

		url?: string;

		method?: string;

		params?: any;

		data?: any;

		headers?: angular.IHttpRequestConfigHeaders;

		xsrfHeaderName?: string;

		xsrfCookieName?: string;

		transformRequest?: angular.IHttpRequestTransformer | angular.IHttpRequestTransformer[];

		transformResponse?: angular.IHttpResponseTransformer | angular.IHttpResponseTransformer[];

		paramSerializer?: string | ((obj: any) => string);

		cache?: any;

		timeout?: number | angular.IPromise<any>;

		withCredentials?: boolean;

		responseType?: string;

		deferUserMessageDisplay?: boolean;

		successMessage?: string;

		suppressSuccessMessage?: boolean;

		authenticated?: boolean;

		suppressHttpErrorDisplay?: boolean;

	}

}